module.exports = __webpack_public_path__ + "img/thumb-008-09.89945deb.png";